export default __webpack_public_path__ + "static/media/dreamer.158637cd.png";